import {useEffect} from 'react'

let firstRender = true

const useTransitionForStepChanging = (currentStep: number, nodeId: string) => {
    useEffect(() => {
        if (firstRender) {
            firstRender = !firstRender
            return
        }

        const headerNode = document.getElementById(nodeId)

        if (headerNode.scrollIntoView) {
            headerNode.scrollIntoView({behavior: 'smooth'})
        } else {
            window.location.hash = ''
            window.location.hash = `#${nodeId}`
        }
    }, [currentStep])
}

export default useTransitionForStepChanging
